import { LayoutHOC } from 'base/ui/layout/layout';
import createChangePassword from '.';
import { IAccountServices } from 'services/RawData/account_services';

export const createChangePasswordPage = (layoutHOC: LayoutHOC, service: IAccountServices) => {
    return layoutHOC(createChangePassword(service));
};
